export const getCampaign = (date: Date) => {
  const day = date.toUTCString()
  const month = day.slice(8, 11)
  const year = day.slice(11, 16)
  let campaign = 0
  const months = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr']
  if (months.includes(month)) {
    campaign = parseInt(year) - 1

    return `${campaign}/${campaign + 1}`
  } else {
    campaign = parseInt(year)

    return `${campaign}/${campaign + 1}`
  }
}

export const getCampaignStartingOnJuly = (date: Date) => {
  const day = date.toUTCString()
  const month = day.slice(8, 11)
  const year = day.slice(11, 16)
  let campaign = 0
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
  if (months.includes(month)) {
    campaign = parseInt(year) - 1

    return `${campaign}_${campaign + 1}`
  } else {
    campaign = parseInt(year)

    return `${campaign}_${campaign + 1}`
  }
}
